import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import ExportIcon from 'icons/ExportIcon';
import { AccordionDetails, Box, IconButton, IconButtonProps } from '@mui/material';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import CustomText from 'components/common/CustomText/CustomText';
import PDFIcon from 'icons/PDFIcon';
import ExcelIcon from 'icons/ExcelIcon';
import RegistriesIcon from 'icons/RegistriesIcon';
import { useExportCases } from 'hooks/useCases';
import { useAuth } from 'context/AuthContext';
import { EExportType } from 'enum/EExportType';
import { useRef } from 'react';
import { snackbarService } from 'services/snackbarService';
import { exportNote } from 'common/constants';
import ExportToRegistriesButton from '../ExportToRegistriesButton/ExportToRegistriesButton';


interface Props extends IconButtonProps {
  ids: number[];
}

export default function ExportCasesButton({ ids, ...props }: Props) {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();
  const ref = useRef<any>(null);

  const { mutate: exportMutation } = useExportCases(
    (res: any) => {
      const { data, status_code: statusCode } = res;
      if (statusCode == 200) {
        snackbarService.showSnackbar(exportNote, 'info', 8000);
      } else {
        snackbarService.showSnackbar(data, 'error');
      }
    },
    () => { },
  )

  const closePopup = () => {
    ref.current.close();
  }

  const exportToExcel = () => {
    closePopup();
    exportMutation({
      userId: user.id,
      dto: {
        procedure_ids: ids,
        type: EExportType.EXCEL
      }
    })
  }

  const exportToPdf = () => {
    closePopup();
    exportMutation({
      userId: user.id,
      dto: {
        procedure_ids: ids,
        type: EExportType.PDF
      }
    })
  }

  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      {(popupState) => {
        ref.current = popupState;
        return (
          <div>
            <CustomButton
              {...bindTrigger(popupState)}
              text='Export'
              variant='outlined'
              intent='primary'
              height={40}
              startIcon={<ExportIcon size={14} />}
            />
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <AccordionDetails sx={{ maxWidth: 300 }}>

                <IconButton className={globalStyles.popoverButtonContainer} onClick={exportToExcel}>
                  <Box className={globalStyles.popoverIconContainer}>
                    <ExcelIcon size={20} />
                  </Box>
                  <CustomText text="Export to Excel file" ml="5px" color={colors.black} />
                </IconButton>

                <IconButton className={globalStyles.popoverButtonContainer} onClick={exportToPdf}>
                  <Box className={globalStyles.popoverIconContainer}>
                    <PDFIcon size={20} />
                  </Box>
                  <CustomText text="Export to PDF file" ml="5px" color={colors.black} />
                </IconButton>


                <ExportToRegistriesButton ids={ids} onClose={closePopup} />

              </AccordionDetails>
            </Popover>
          </div>
        )
      }}
    </PopupState>
  );
}
